import { useCallback, useRef } from 'react';

// KDS hands a Popover's `toggle` out through its ref. Holding that instance in
// state leaves the trigger inert on the render where it first paints — the ref
// callback only lands afterwards — so an early click does nothing and any
// chevron gated on `toggle` pops in a frame later.
//
// A ref plus a stable callback closes the window: the trigger always calls
// whatever the popover currently is, and nothing re-renders to wire it up.
export default function usePopoverToggle() {
  const popover = useRef(null);

  const popoverRef = useCallback((instance) => {
    popover.current = instance;
  }, []);

  const toggle = useCallback((...args) => popover.current?.toggle(...args), []);

  return { popoverRef, toggle };
}
